/*Global Variables*/
   var allProducts = document.querySelectorAll(".collection-slide:has(.group-card-wrapper)");
   var bestSellers = document.querySelectorAll(".collection-slide:has(.best_sellers)");
   var newProducts = document.querySelectorAll(".collection-slide:has(.new)");
   var bundles = document.querySelectorAll(".collection-slide:has([data-group='data_bundles'])");
   var collection_title = document.querySelector(".group-collection-title"); 
   var filterBtns= document.querySelectorAll(".filter-btn");

/*Show All*/
    function showAll() {
     for(var e = 0; e < allProducts.length; e++) {
        allProducts[e].style.display = "list-item";
    }
   }

/*Hide All*/
  function hideAll() {
     for(var e = 0; e < allProducts.length; e++) {
        allProducts[e].style.display = "none";
    }
  }

  function resetAllBtns() {
   for(var a = 0; a < filterBtns.length; a++ ) {
       filterBtns[a].style.backgroundColor = "#FBF6ED";
       filterBtns[a].style.color = "#231F20";
     }
  }

/*Best Sellers*/
   document.getElementById("best_sellers_btn").onclick = function() {
    hideAll();
    resetAllBtns();
    collection_title.innerHTML = 'Best Sellers' ;
    for(var i= 0; i < bestSellers.length; i++) {
      bestSellers[i].style.display = 'list-item';
    }
    document.getElementById("best_sellers_btn").style.backgroundColor = "#231F20";
    document.getElementById("best_sellers_btn").style.color = "#fff";
   };

/*New*/
   document.getElementById("new_btn").onclick = function() {
     hideAll();
     resetAllBtns();
     collection_title.innerHTML = 'New' ;
     for(var i= 0; i < newProducts.length; i++) {
         newProducts[i].style.display = 'list-item';
     }
     document.getElementById("new_btn").style.backgroundColor = "#231F20";
     document.getElementById("new_btn").style.color = "#fff";
  };

/*Bundles Sellers*/
   document.getElementById("bundles_btn").onclick = function() {
     hideAll();
     resetAllBtns();
     collection_title.innerHTML = 'Bundles';
     for(var i= 0; i < bundles.length; i++) {
         bundles[i].style.display = 'block';
     }
     document.getElementById("bundles_btn").style.backgroundColor = "#231F20";
     document.getElementById("bundles_btn").style.color = "#fff";
   };

/*All Products*/
    document.getElementById("all_btn").onclick = function() {
      collection_title.innerHTML = 'All Products';
      showAll();
      resetAllBtns();
      document.getElementById("all_btn").style.backgroundColor = "#231F20";
      document.getElementById("all_btn").style.color = "#fff";
   };


/* Skin Quiz Modal */
/*
function openModal(){
 const modal = document.querySelector(".quiz-modal");
 const background = document.querySelector("body.gradient.animate--hover-default");
    modal.style.display = "block";
  
}

 function closeModal(){
    const modal = document.querySelector(".quiz-modal");
    modal.style.display = "none";
}
*/
